import { render, staticRenderFns } from "./selection-region.vue?vue&type=template&id=934ff538&scoped=true&"
import script from "./selection-region.vue?vue&type=script&lang=ts&"
export * from "./selection-region.vue?vue&type=script&lang=ts&"
import style0 from "./selection-region.vue?vue&type=style&index=0&id=934ff538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934ff538",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VSelect})
